export default "__VITE_ASSET__384434b0__"